import styled from "styled-components";
import Card from "./components/Card";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useRef } from "react";

const MobileContainer1 = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  min-width: 360px;
  height: 239px;
  width: 100%;
  background-image: url("/img/main.png");
  background-size: cover;
  background-position: center center;
  /* background: linear-gradient(180deg, #3ac887 0%, #ffffff 85%); */
`;

const MobileContainer11 = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  min-width: 360px;
  height: 239px;
  width: 100%;
  background-size: cover;
  background-position: center center;
  /* background: linear-gradient(180deg, #3ac887 0%, #ffffff 85%); */
`;

const MobileContent1 = styled.div`
  width: 360px;
  height: 239px;
  /* background-image: url("/img/mobileHome.png"); */
  background-size: cover;
  position: relative;
`;

const MobileWhiteLogo = styled.img`
  position: absolute;
  left: 20px;
  bottom: 30px;
  width: 120px;
`;

const MobileContainer2 = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  min-width: 360px;
  width: 100%;
  height: 700px;
`;

const MobileContent2 = styled.div`
  width: 360px;
  height: 700px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileContent2Logo = styled.img`
  margin-top: 210px;
  width: 164px;
  height: 53.68px;
`;

const MobileContent2Title = styled.div`
  margin-top: 40px;
  font-size: 28px;
  font-weight: 600;
  color: #292929;
`;

const MobileContent2Des = styled.div`
  margin-top: 40px;
  text-align: center;
  line-height: 32px;
  color: #292929;
`;

const MobileLeftImg = styled.img`
  width: 66.92px;
  position: absolute;
  top: 88px;
  left: 28px;
`;

const MobileRightImg = styled.img`
  width: 66.92px;
  position: absolute;
  top: 550px;
  left: 271px;
`;

const MobileContainer3 = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  min-width: 360px;
  width: 100%;
  height: 700px;
  background-color: rgba(58, 200, 135, 0.08);
`;

const MobileContent3 = styled.div`
  width: 360px;
  height: 700px;
  min-width: 360px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileContent3Img = styled.img`
  width: 222px;
  margin-top: 181px;
`;

const MobileContent3Line = styled.div`
  width: 20px;
  height: 3px;
  position: absolute;
  top: 35px;
  left: 25px;
  background-color: #3ac887;
`;

const MobileContent3Title = styled.div`
  font-size: 28px;
  color: #292929;
  position: absolute;
  left: 25px;
  top: 55px;
  font-weight: 600;
`;

const MobileContent3Des = styled.div`
  color: #292929;
  position: absolute;
  top: 108px;
  left: 25px;
  line-height: 28px;
`;

const MobileContainer4 = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  width: 100%;
  height: 767px;
  min-width: 360px;
  background-color: rgba(58, 200, 135, 0.08);
`;

const MobileContent4 = styled.div`
  width: 360px;
  height: 765px;
  position: relative;
  min-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileContent4Img = styled.img`
  width: 222px;
  margin-top: 235px;
`;

const MobileContent4Line = styled.div`
  width: 20px;
  height: 3px;
  position: absolute;
  top: 35px;
  left: 25px;
  background-color: #3ac887;
`;

const MobileContent4Title = styled.div`
  font-size: 28px;
  color: #292929;
  position: absolute;
  left: 25px;
  top: 55px;
  font-weight: 600;
`;

const MobileContent4Des = styled.div`
  color: #292929;
  position: absolute;
  top: 108px;
  left: 25px;
  line-height: 28px;
`;

const MobileContainer5 = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  width: 100%;
  height: 514px;
  min-width: 360px;
`;

const MobileContent5 = styled.div`
  width: 360px;
  min-width: 360px;
  height: 514px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileContent5Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-top: 70px;
  line-height: 34px;
  color: #292929;
`;

const MobileContent5Des = styled.div`
  margin-top: 50px;
  text-align: center;
  line-height: 32px;
  font-size: 16px;
  color: #292929;
`;

const MobileContent5Tag = styled.div`
  color: #53a2ff;
  padding: 10px 25px;
  border: 1px solid #53a2ff;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 124px;
  margin-top: 66px;
`;

const MobileContainer6 = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  width: 100%;
  height: 916px;
  min-width: 360px;
`;

const MobileContent6 = styled.div`
  width: 360px;
  min-width: 360px;
  height: 916px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileContainer7 = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  width: 100%;
  height: 1136px;
  min-width: 360px;
`;

const MobileContent7 = styled.div`
  width: 360px;
  min-width: 360px;
  height: 916px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileContent7Title = styled.div`
  text-align: center;
  line-height: 40px;
  font-size: 24px;
  margin-top: 35px;
`;

const MobileContent7Tag1 = styled.div`
  color: #53a2ff;
  padding: 10px 25px;
  border: 1px solid #53a2ff;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 124px;
  margin-top: 70px;
`;

const MobileContent7Des1 = styled.div`
  line-height: 28px;
  margin-top: 30px;
  text-align: center;
  color: #292929;
`;

const MobileContent7TopImg = styled.img`
  margin-top: 50px;
  width: 336px;
`;
const MobileContent7TopHouse = styled.img`
  margin-top: 50px;
  width: 335px;
`;

const MobileContent7Tag2 = styled.div`
  color: #53a2ff;
  padding: 10px 25px;
  border: 1px solid #53a2ff;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 124px;
  margin-top: 100px;
`;

const MobileContent7Des2 = styled.div`
  line-height: 28px;
  margin-top: 30px;
  text-align: center;
  color: #292929;
`;
const MobileContent7BottomImg = styled.img`
  margin-top: 50px;
  width: 336px;
`;
const MobileContent7BottomHouse = styled.img`
  margin-top: 50px;
  width: 335px;
`;

const MobileContainer8 = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  width: 100%;
  height: 238px;
  min-width: 360px;
`;

const MobileContent8 = styled.div`
  width: 360px;
  min-width: 360px;
  height: 238px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileContent8Title = styled.div`
  text-align: center;
  color: #292929;
  font-size: 28px;
  margin-top: 123px;
  line-height: 38px;
  font-weight: 600;
  margin-bottom: 39px;
`;

const MobileContainer9 = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  width: 100%;
  height: 755px;
  min-width: 360px;
  background-color: rgba(255, 216, 117, 0.07);
`;

const MobileContent9 = styled.div`
  width: 360px;
  min-width: 360px;
  height: 755px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileContent8Img = styled.img`
  margin-top: 286px;
  width: 235px;
`;

const MobileContent8BoxTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 38px;
  position: absolute;
  top: 30px;
  left: 25px;
  color: #292929;
`;

const MobileContent8BoxDes = styled.div`
  line-height: 28px;
  position: absolute;
  top: 167px;
  left: 25px;
  color: #292929;
`;

const MobileContainer10 = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  width: 100%;
  height: 720px;
  min-width: 360px;
  background-color: rgba(58, 200, 135, 0.08);
`;

const MobileContent10 = styled.div`
  width: 360px;
  min-width: 360px;
  height: 720px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileContent10Img = styled.img`
  margin-top: 73px;
  height: 394px;
`;

const MobileContent10Title = styled.div`
  font-size: 24px;
  line-height: 39px;
  font-weight: 600;
  text-align: center;
  margin-top: 58px;
  color: #292929;
`;

const MobileContent10DownBox = styled.div`
  margin-top: 30px;
  display: flex;
  gap: 15px;
`;

const Android = styled.img`
  height: 40px;
`;

const Apple = styled.img`
  height: 40px;
`;

const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  width: 100%;
  min-width: 360px;
  background-color: white;
`;

const FooterContent = styled.div`
  width: 360px;
  min-width: 360px;
  padding: 40px 0 28px 0; /* 위/아래 여백 */
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CompanyRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Company = styled.div`
  color: #5a5a5a;
  font-weight: 600;
`;

const CompanyToggle = styled.div`
  font-size: 13px;
  color: #888888;
  cursor: pointer;
  user-select: none;
`;

const CompanyLine = styled.div`
  width: 100%;
  height: 1px;
  background: #cfcfcf;
`;

const CompanyDes = styled.div`
  line-height: 32px;
  color: #888888;

  overflow: hidden;
  max-height: ${(props) => (props.$open ? "500px" : "0px")};
  transition: max-height 220ms ease;
`;

const CompanyNotice = styled.div`
  color: #888888;
  font-size: 12px;
  line-height: 18px;
`;

const CompanyPolicy = styled.div`
  font-weight: 600;
  color: #888888;
  cursor: pointer;
`;

const MobileHome = () => {
  const navigate = useNavigate();
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);
  const footerBottomRef = useRef(null);
  return (
    <>
      <MobileContainer1>
        <MobileContent1>
          <MobileWhiteLogo src="/img/LogoWhite.png" />
        </MobileContent1>
      </MobileContainer1>
      <MobileContainer11>
        <MobileContent10>
          <MobileContent10Title>
            믿을 수 있는 이웃, <span style={{ color: "#50B385" }}>월리</span>
            에게
            <br />
            반려동물을 맡겨보세요!
          </MobileContent10Title>
          <MobileContent10DownBox>
            <a href="https://play.google.com/store/apps/details?id=com.flynnapps.wally">
              <Android src="/img/android.png" />
            </a>
            <a href="https://apps.apple.com/kr/app/%EC%9B%94%EB%A6%AC-%EC%9A%B0%EB%A6%AC-%EB%8F%99%EB%84%A4-%ED%8E%AB%EC%8B%9C%ED%84%B0-%EC%B0%BE%EA%B8%B0/id6741297868">
              <Apple src="/img/apple.png" />
            </a>
          </MobileContent10DownBox>
        </MobileContent10>
      </MobileContainer11>
      <MobileContainer2>
        <MobileContent2>
          <MobileContent2Logo src="/img/logo.png" />
          <MobileContent2Title>월리 서비스 소개</MobileContent2Title>
          <MobileContent2Des>
            월리 서비스는
            <br />
            <span style={{ fontWeight: 600 }}>
              우리 동네의 믿을 수 있는 이웃 주민{" "}
              <span style={{ color: "#50B385" }}>월리</span>
            </span>
            가 <br />
            반려동물을 돌봐주는
            <br />
            <span style={{ fontWeight: 600 }}>
              반려동물 집중케어 돌봄 서비스
            </span>
            에요.
          </MobileContent2Des>
          <MobileLeftImg src="/img/left.png" />
          <MobileRightImg src="/img/right.png" />
        </MobileContent2>
      </MobileContainer2>
      <MobileContainer3>
        <MobileContent3>
          <MobileContent3Line />
          <MobileContent3Title>월리는 누구일까요?</MobileContent3Title>
          <MobileContent3Des>
            월리는 우리 동네의 친근하고, 믿을 수 있는 <br />
            <span style={{ fontWeight: 600 }}>
              이웃 주민이자 반려동물 돌봄 시터
            </span>
            에요.
          </MobileContent3Des>
          <MobileContent3Img src="/img/mobilemockup1.png" />
        </MobileContent3>
      </MobileContainer3>
      <MobileContainer4>
        <MobileContent4>
          <MobileContent4Line />
          <MobileContent4Title>월리만의 차별점은?</MobileContent4Title>
          <MobileContent4Des>
            월리는{" "}
            <span style={{ fontWeight: 600 }}>
              많은 반려견을 한번에 돌보는 애견호텔과는
              <br /> 달리
            </span>{" "}
            보호자분의 반려동물만을{" "}
            <span style={{ fontWeight: 600 }}>
              ‘집중케어'하여 세심 <br />
              하게 돌봐요!
            </span>
          </MobileContent4Des>
          <MobileContent4Img src="/img/mobilemockup2.png" />
        </MobileContent4>
      </MobileContainer4>
      <MobileContainer5>
        <MobileContent5>
          <MobileContent5Title>
            동네 이웃 누구나
            <br />
            월리를 지원할 수 있어요.
            <br />
            하지만,
            <br />
            아무나 월리가 될 수는 없어요!
          </MobileContent5Title>
          <MobileContent5Des>
            소중한 반려동물에게 문제가 생기지 않도록 <br />
            월리 서비스만의 선별 과정으로 <br />
            인증된 월리만을 선정하여
            <br />
            반려동물 돌봄 서비스를 운영하고 있어요!{" "}
          </MobileContent5Des>
          <MobileContent5Tag>지원 과정</MobileContent5Tag>
        </MobileContent5>
      </MobileContainer5>
      <MobileContainer6>
        <MobileContent6>
          <Card
            DesWidth={260}
            paddingLeft={40}
            paddingTop={40}
            width={340}
            height={184}
            marginTop={30}
            titleFontSize={21}
            desFontSize={15}
            marginBottom={20}
            lineHeight={26}
            title="신분 인증 및 확인"
            des="안전한 돌봄을 위해 만 19세 이상 이웃만 본인 인증을 통해 월리로 지원이 가능해요!"
          />
          <Card
            DesWidth={260}
            paddingLeft={40}
            paddingTop={40}
            width={340}
            height={184}
            marginTop={244}
            titleFontSize={21}
            desFontSize={15}
            marginBottom={20}
            lineHeight={26}
            title="반려동물 돌본 경험 확인"
            des="월리는 반드시 반려동물을 키워본 경험이
있는 분으로만 선정하고 있어요!"
          />
          <Card
            DesWidth={260}
            paddingLeft={40}
            paddingTop={40}
            width={340}
            height={184}
            marginTop={458}
            titleFontSize={21}
            desFontSize={15}
            marginBottom={20}
            lineHeight={26}
            title="반려동물 관련 가치관 확인 "
            des="반려동물에 대한 태도나 긍정적인 가치관을
올바르게 가지고 있는지 면밀히 확인해요!"
          />
          <Card
            DesWidth={260}
            paddingLeft={40}
            paddingTop={40}
            width={340}
            height={184}
            marginTop={672}
            titleFontSize={21}
            desFontSize={15}
            marginBottom={20}
            lineHeight={26}
            title="친절한 서비스 응대"
            des="돌봄 진행 시 보호자분들에게 서비스 응대
및 소통이 원활한 분을 월리로 선정해요!"
          />
        </MobileContent6>
      </MobileContainer6>
      <MobileContainer7>
        <MobileContent7>
          <MobileContent7Title>
            <span style={{ fontWeight: 600 }}>원하는 장소와 시간</span>만
            선택하면,
            <br />{" "}
            <span style={{ fontWeight: 600, color: "#50B385" }}>
              월리 혹은 보호자분의 집에서
              <br /> 돌봄
            </span>
            이 가능해요!
          </MobileContent7Title>
          <MobileContent7Tag1>돌봄 숙소</MobileContent7Tag1>
          <MobileContent7Des1>
            월리의 집에 보호자님의 반려동물을 맡기고,
            <br />
            월리가 직접 돌봐요!
          </MobileContent7Des1>
          <MobileContent7TopImg src="/img/leftDes.png" />
          <MobileContent7TopHouse src="/img/leftHouse.png" />
          <MobileContent7Tag2>방문 돌봄</MobileContent7Tag2>
          <MobileContent7Des2>
            보호자님의 집에 월리가 직접 방문하여,
            <br />
            반려동물을 돌봐요!
          </MobileContent7Des2>
          <MobileContent7BottomImg src="/img/rightDes.png" />
          <MobileContent7BottomHouse src="/img/rightHouse.png" />
        </MobileContent7>
      </MobileContainer7>
      <MobileContainer8>
        <MobileContent8>
          <MobileContent8Title>
            소중한 나의 반려동물,
            <br />
            지금 잘 있을까?
          </MobileContent8Title>
        </MobileContent8>
      </MobileContainer8>
      <MobileContainer9>
        <MobileContent9>
          {" "}
          <MobileContent8BoxTitle>
            돌봄 일지로
            <br />
            실시간 돌봄 현황을
            <br />
            확인해요!
          </MobileContent8BoxTitle>
          <MobileContent8BoxDes>
            <span style={{ fontWeight: 600 }}>‘돌봄 일지'</span> 기능을 통해
            돌봄 진행 중<br />
            반려동물 돌봄 영상과 사진을 지속적으로 <br />
            전송하므로 보호자분이 안심하고 맡길 수 있어요!
          </MobileContent8BoxDes>
          <MobileContent8Img src="/img/list.png" />
        </MobileContent9>
      </MobileContainer9>
      <MobileContainer10>
        <MobileContent10>
          <MobileContent10Img src="/img/mobiledownload.png" />
          <MobileContent10Title>
            믿을 수 있는 이웃, <span style={{ color: "#50B385" }}>월리</span>
            에게
            <br />
            반려동물을 맡겨보세요!
          </MobileContent10Title>
          <MobileContent10DownBox>
            <a href="https://play.google.com/store/apps/details?id=com.flynnapps.wally">
              <Android src="/img/android.png" />
            </a>
            <a href="https://apps.apple.com/kr/app/%EC%9B%94%EB%A6%AC-%EC%9A%B0%EB%A6%AC-%EB%8F%99%EB%84%A4-%ED%8E%AB%EC%8B%9C%ED%84%B0-%EC%B0%BE%EA%B8%B0/id6741297868">
              <Apple src="/img/apple.png" />
            </a>
          </MobileContent10DownBox>
        </MobileContent10>
      </MobileContainer10>
      <FooterContainer>
        <FooterContent>
          <CompanyRow>
            <Company>(주)월리</Company>
            <CompanyToggle
              onClick={() => {
                setIsCompanyOpen((prev) => {
                  const next = !prev;

                  // 🔽 펼쳐질 때만 스크롤
                  if (!prev) {
                    setTimeout(() => {
                      footerBottomRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "end",
                      });
                    }, 250); // 애니메이션 끝난 뒤
                  }

                  return next;
                });
              }}
            >
              {isCompanyOpen ? "▲" : "▼"}
            </CompanyToggle>
          </CompanyRow>

          <CompanyLine />

          <CompanyDes $open={isCompanyOpen}>
            부산광역시 기장군 기장읍 기장대로 82-8
            <br />
            사업자 등록번호: 323-88-03325 | 대표: 이승철
            <br />
            통신판매신고번호: 2025-부산기장-0252
            <br />
            대표번호: 010-6290-2786
            <br />
            문의메일: admin@wallykorea.com
          </CompanyDes>

          <CompanyNotice>(주)월리는 통신판매중개자이며, 통신판매의 당사자가 아닙니다.  따라서 (주)월리는 서비스 거래 정보 및 거래에 책임을 지지 않습니다.</CompanyNotice>

          <CompanyPolicy onClick={() => navigate("policy")}>
            개인정보처리방침
          </CompanyPolicy>
          <div ref={footerBottomRef} />
        </FooterContent>
      </FooterContainer >
    </>
  );
};

export default MobileHome;
